import { GridCellProps } from '@progress/kendo-react-grid';
import { AdminCheckBox } from 'app/components/AdminCheckbox';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const SplitDivisonCell = ({ className, e, onClick }: Props) => {
  const data = e.dataItem;
  return (
    <td className={className ?? ''}>
      <div>{data.division}</div>
    </td>
  );
};

export default SplitDivisonCell;
